import React, { useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"

import styles from "../CompanyOpportunities/CompanyOpportunities.module.scss"
import privateStyles from "./CompanyPrivateOpportunities.module.scss"
import CompanyInfoItem from "../CompanyInfoItem/CompanyInfoItem"
import OpportunityCard from "../cards/OpportunityCard"
import CompanyAddonTypePopup from "../CompanyAddonTypePopup"
import { opportunitiesTypeCards } from "../Opportunity/heplers"
import { DEFAULT_PROFILE_IMAGE as avatar } from "../../helpers/profileImage"
import ButtonComponent from "../Button/Button"
import { COMPANY_PROVIDER } from "../../helpers/userRoles"
import { ReactComponent as ShareIcon } from "../../images/icons/shareIcon.svg"

const CompanyPrivateOpportunities = ({ data, width, anotherUser, uuid }) => {
  const [visiblePopup, setVisiblePopup] = useState(false)
  const history = useHistory()
  const userInfo = useSelector((state) => state.user)
  const isCompanyProvider = userInfo?.company?.type === COMPANY_PROVIDER
  const canShare = !anotherUser && isCompanyProvider

  const handleClick = (e, opportunitie) => {
    if (e.target.dataset.type !== "button") {
      history.push(`/opportunity?id=${opportunitie["uuid"]}`)
    }
  }

  const tooltipText = data?.departments?.length
    ? null
    : "Please add at least one department before adding an opportunity."

  const placeholder =
    anotherUser && !data?.private_opportunities?.length
      ? "No private opportunity yet"
      : data?.private_opportunities?.length > 0
      ? null
      : "You didn't add any private opportunities yet"

  const addButtonDisabledStatus = !data?.departments?.length

  return (
    <CompanyInfoItem
      tooltipText={tooltipText}
      headTitle={
        anotherUser
          ? "Company/Organization Private Opportunities"
          : "My Private Opportunities"
      }
      disabled={addButtonDisabledStatus}
      headBtnText={
        width < 451
          ? "Add"
          : width < 600
          ? "Add Private"
          : "Add Private Opportunity"
      }
      bodyPlaceholderText={placeholder}
      handleButtonClick={() => {
        setVisiblePopup(true)
      }}
      width={width}
      anotherUser={anotherUser}
    >
      <div className={styles.oppotunitiesWrapper}>
        {visiblePopup && (
          <CompanyAddonTypePopup
            width={953}
            closeAction={setVisiblePopup}
            title="Add Private Opportunity"
            handleNextClick={(a) =>
              history.push(
                `/opportunity-edit?variant=${a.type}&is_private=true`,
              )
            }
            data={opportunitiesTypeCards.map((card) => ({
              ...card,
              title: `Private ${card.title}`,
            }))}
          />
        )}
        {data.private_opportunities?.length > 0 && (
          <>
            <div className={styles.cardsWrapper}>
              {data.private_opportunities.map((opportunitie) => (
                <div key={opportunitie["created_at"]} className={privateStyles.opportunityCardWrapper}>
                  <OpportunityCard
                    uuid={opportunitie.uuid}
                    type={opportunitie["opportunity_type"]}
                    avatar={data.photo || avatar}
                    description={opportunitie["description"]}
                    location={{
                      city: opportunitie["location"],
                      head: data.name,
                    }}
                    caption={opportunitie["name"]}
                    timestamp={new Date(opportunitie["created_at"])}
                    onClick={(e) => handleClick(e, opportunitie)}
                    isFavorite={opportunitie["favorite"]}
                    isPrivate={true}
                  />
                  {canShare && (
                    <div className={privateStyles.shareButtonWrapper}>
                      <ButtonComponent
                        buttonStyle="contained"
                        className={privateStyles.shareButton}
                        onClick={(e) => {
                          e.stopPropagation()
                          history.push(`/opportunities/${opportunitie.uuid}/share`)
                        }}
                        data-type="button"
                      >
                        <ShareIcon className={privateStyles.shareIcon} />
                        Share Opportunity
                      </ButtonComponent>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {data.private_opportunities.length >= 2 && (
              <div className={styles.showMoreBtn}>
                <Link
                  to={`/opportunities/${uuid}?is_private=true`}
                  className={classNames("goldLink")}
                >
                  <p>Show all private opportunities</p>
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </CompanyInfoItem>
  )
}

export default CompanyPrivateOpportunities
